import { FC, SVGProps } from "react";

const EditIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentcolor"
      {...props}
    >
      <path d="M4.33654 14.75H0.5L0.5 10.906L8.44712 2.94352M4.33654 14.75L14.75 14.75M4.33654 14.75L12.2837 6.78749M8.44712 2.94352L10.0913 1.29611C11.1508 0.234623 12.8685 0.234625 13.9279 1.29611C14.9873 2.35759 14.9873 4.0786 13.9279 5.14008L12.2837 6.78749M8.44712 2.94352L12.2837 6.78749" />
    </svg>
  );
};

export default EditIcon;
